<template>
	<div id="article-create">
		<div class="container">
			<el-input v-model="form.title" placeholder="标题" />
			<br />
			<br />
			<div id="editor" palceholder="内容"></div>
			<br />
			<el-date-picker v-model="form.pubtime" type="date" placeholder="发布日期"></el-date-picker>
			<br />
			<br />
			<el-select v-model="form.type" placeholder="类别">
				<el-option v-for="item in types" :key="item.id" :label="item.text" :value="item.id"></el-option>
			</el-select>
			<br />
			<br />
			<el-upload class="upload-demo" drag :action="uploadUrl" :on-success="success">
				<i class="el-icon-upload"></i>
				<div class="el-upload__text">
					将视频文件拖到此处，或
					<em>点击上传</em>
				</div>
			</el-upload>
			<el-upload class="upload-demo" drag :action="uploadUrl" :on-success="successThumb">
				<i class="el-icon-upload"></i>
				<div class="el-upload__text">
					将视频封面拖到此处，或
					<em>点击上传</em>
				</div>
			</el-upload>
			<br />
			<br />
			<el-button type="primary" @click="submit">提交</el-button>
		</div>
	</div>
</template>
<script>
	import Vue from "vue";
	import {
		Button,
		Radio,
		Input,
		Message,
		DatePicker,
		Select,
		Option,
		Upload
	} from "element-ui";
	Vue.use(Button);
	Vue.use(Input);
	Vue.use(DatePicker);
	Vue.use(Select);
	Vue.use(Option);
	Vue.use(Radio);
	Vue.use(Upload);

	import E from "wangeditor";
	export default {
		components: {
			E
		},
		data() {
			return {
				editor: null,
				types: [],
				form: {}
			};
		},
		computed: {
			uploadUrl() {
				return this.$util.apiUrl("/upload/video");
			}
		},
		mounted() {
			this.setEditor();
			if (this.$route.params.id) {
				this.fetchArticle(this.$route.params.id);
			}
			this.fetchTypes();
		},
		methods: {
			fetchArticle(id) {
				const $this = this;
				this.$util.axios.get(
					this.$util.apiUrl("/article/" + id),
					null,
					function (data) {
						$this.form = data;
						$this.editor.txt.html(data.content);
					}
				);
			},
			fetchTypes() {
				const $this = this;
				this.$util.axios.get(
					this.$util.apiUrl("/article/categories/service"),
					null,
					function (data) {
						$this.types = data;
					}
				);
			},
			setEditor() {
				var editor = new E("#editor");
				//editor.customConfig.uploadImgShowBase64 = true;
				editor.customConfig.uploadImgServer = this.$util.apiUrl(
					"/upload/image"
				);
				editor.customConfig.uploadImgMaxSize = 1 * 1024 * 1024;
				editor.customConfig.uploadFileName = "file";
				editor.customConfig.onchange = html => {
					this.form.content = html;
				};
				editor.customConfig.uploadImgHooks = {
					before: function (xhr, editor, files) {
						// 图片上传之前触发
						// xhr 是 XMLHttpRequst 对象，editor 是编辑器对象，files 是选择的图片文件
						// 如果返回的结果是 {prevent: true, msg: 'xxxx'} 则表示用户放弃上传
						// return {
						//     prevent: true,
						//     msg: '放弃上传'
						// }
					},
					success: function (xhr, editor, result) {
						// 图片上传并返回结果，图片插入成功之后触发
						// xhr 是 XMLHttpRequst 对象，editor 是编辑器对象，result 是服务器端返回的结果
					},
					fail: function (xhr, editor, result) {
						// 图片上传并返回结果，但图片插入错误时触发
						// xhr 是 XMLHttpRequst 对象，editor 是编辑器对象，result 是服务器端返回的结果
					},
					error: function (xhr, editor) {
						// 图片上传出错时触发
						// xhr 是 XMLHttpRequst 对象，editor 是编辑器对象
					},
					timeout: function (xhr, editor) {
						// 图片上传超时时触发
						// xhr 是 XMLHttpRequst 对象，editor 是编辑器对象
					},

					// 如果服务器端返回的不是 {errno:0, data: [...]} 这种格式，可使用该配置
					// （但是，服务器端返回的必须是一个 JSON 格式字符串！！！否则会报错）
					customInsert: function (insertImg, result, editor) {
						console.log(insertImg, result);
						// 图片上传并返回结果，自定义插入图片的事件（而不是编辑器自动插入图片！！！）
						// insertImg 是插入图片的函数，editor 是编辑器对象，result 是服务器端返回的结果
						result.data.map(function (url) {
							insertImg(url);
						});

						// 举例：假如上传图片成功后，服务器端返回的是 {url:'....'} 这种格式，即可这样插入图片：
						//var url = result.url
						//insertImg(url)

						// result 必须是一个 JSON 格式字符串！！！否则报错
					}
				};
				editor.create();
				this.editor = editor;
			},

			submit() {
				const $this = this;
				this.$util.axios.post(
					this.$util.apiUrl("/article/create"),
					this.form,
					function (data) {
						console.log(data);
						if (data.status != 200) {
							return Message.error(data.message);
						}
						if (!$this.form.id) {
							$this.form = {};
						}
						return Message.success(data.message);
					}
				);
			},

			success(response, file, fileList) {
				this.form.video = response.data[0];
			},
			successThumb(response, file, fileList) {
				this.form.video_thumb = response.data[0];
			}
		}
	};
</script>